// extracted by mini-css-extract-plugin
module.exports = {"cover":"Content_cover__tCorj","content":"Content_content__2oJDW","footerText":"Content_footerText__BVK_i"};